import { createState, useState } from '@hookstate/core';
import Logo from '../assets/images/logo.svg';
import { DEFAULT_COLOR } from '../constants/Constant';
import Helper from '../utility/helper';
const initialState = {
    primary: '#17408B',
    header: '#17408B',
    secondary: '#E1072A',
    altprimary: '#06255B',
    submit: '#F9B811',
    approve: '#169D3C',
    leftnav: '#394150',
    appbackground: '#FFFFFF',
    eventEnabled: false,
    tableHead: '#E3EDFF',
    tableHeadText: '#424242',
    imageUrl: Logo,
    eventImageUrl: '',
};

const themeState = createState(initialState);

export const setTheme = (props) => {
    if (props) {
        const color = props.color ? JSON.parse(props.color) : '';

        themeState.set({
            ...initialState,
            primary: "#17408B",
            header: color ? color.primary : DEFAULT_COLOR.primary,
            secondary: color ? color.secondary : DEFAULT_COLOR.secondary,
            imageUrl: props.imageUrl,
            eventImageUrl: props.eventImageUrl,
            eventEnabled: true,
        });
    }
    return;
};
export const useThemeState = () => {
    return useState(themeState);
};
export const exitTheme = () => {
    Helper.removeStorage('eventInfo');
    Helper.removeStorage('eventModuleConfig');
    themeState.set(initialState);
};
